// extracted by mini-css-extract-plugin
module.exports = {"container":"Subscription_container__10NI_","subscriptionLink":"Subscription_subscriptionLink__1qNux"};